module.exports = " <a class=announcement-wrapper v-if=show> <div class=announcement> <i v-on:click=close class=\"paco icon-close icon\"></i> <span class=message> <slot></slot> </span> </div> </a> ";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Announcement.vue
// module id = 120
// module chunks = 1